package at.theatervogelweide.admin.web.components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.attributes.ButtonType
import org.jetbrains.compose.web.attributes.type
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

private val chips = Bem("admin-filter-chips")

/** One chip; [count] is left out of the label while it is 0. */
data class FilterOption<T>(val value: T, val label: String, val count: Int)

/**
 * Toggle pills that filter a list, each with its count. Exactly one is pressed; "Alle" comes first. Use the Badge
 * words as labels so chips and badges match.
 */
@Composable
fun <T> AdminFilterChips(
    options: List<FilterOption<T>>,
    selected: T,
    onSelect: (T) -> Unit,
    label: String = "Filter",
) {
    Div({
        classes(chips.block)
        attr("role", "group")
        attr("aria-label", label)
    }) {
        options.forEach { option ->
            Button({
                type(ButtonType.Button)
                classes(chips.element("chip").className)
                attr("aria-pressed", (option.value == selected).toString())
                onClick { onSelect(option.value) }
            }) {
                Text(if (option.count > 0) "${option.label} ${option.count}" else option.label)
            }
        }
    }
}
